import { ModuleInfo, SkillSetLevel } from '@suntex.fim/enums'
import { useModuleById } from '@suntex.fim/framework'
import { ModuleLayout } from '@suntex.fim/modules'
import { modulesPath, usePlayerDashboardPath } from '@suntex.fim/nav'
import { usePlayer } from '@suntex.fim/player'

import { skillSetModuleId } from '../../../utils/fimUtils'
import Canvas, { CanvasProperties, ICanvasParameters } from '../Shared/Canvas'

import { Loading } from './Module'
import { ISkillSet, SkillSetGame, toSkillSet } from './skillSetsUtils'

type ISkillSetProps = ISkillSet

export function SkillSet(props: ISkillSetProps) {
  interface ISkillSetCanvasParameters extends ICanvasParameters {
    playerId: number
    moduleId: number
    skillSet: SkillSetLevel
    game: SkillSetGame
    gameNumber: number
  }

  const moduleId = skillSetModuleId(props.level, props.game)

  const module = useModuleById(moduleId)
  const { playerId, isPreview } = usePlayer()
  const hubUrl = usePlayerDashboardPath()
  if (!module) return <Loading />

  const propsCanvas = new CanvasProperties<ISkillSetCanvasParameters>()

  propsCanvas.name = 'SkillSets'
  propsCanvas.width = 700
  propsCanvas.height = 500
  propsCanvas.jsSrc = 'SkillSets.js'
  propsCanvas.preview = isPreview

  propsCanvas.parameters.playerId = playerId
  propsCanvas.parameters.moduleId = moduleId
  propsCanvas.parameters.skillSet = props.level
  propsCanvas.parameters.game = props.game
  propsCanvas.parameters.gameNumber = moduleId
  propsCanvas.parameters.hubUrl = hubUrl

  //if at the last ss game
  if (moduleId === ModuleInfo.ss_8_3) {
    //no next game
    propsCanvas.parameters.nextGameUrl = null
  } else {
    // if the next game is in focus
    //if (isModuleInFocus(moduleId + 1))
    if (true) {
      // convert to skillset
      const nextSS = toSkillSet(moduleId + 1)

      // and set the next game URL
      propsCanvas.parameters.nextGameUrl = `${modulesPath(isPreview)}/ss/${nextSS.level}/${nextSS.game}`
    } else {
    }
  }

  //'and set the next game
  //model.NextGameUrl = $"{model.ModuleUrlBase}/skillsets/{nextSS.SkillSet}/{nextSS.Game}"
  //Else
  //'no next game
  //model.NextGameUrl = Nothing
  //            End If
  //        End If
  //FIM 1.0 has this:
  //model.Round = AppQueryString.r
  //propsCanvas.parameters("pwaMode") = Model.PWAMode

  //function glossary() {
  //  console.log('glossary')
  //}

  return (
    <ModuleLayout moduleId={moduleId} isLegacyModule>
      <div>
        <Canvas {...propsCanvas} />

        {moduleId == ModuleInfo.ss_5_1 && (
          <p style={{ textAlign: 'right' }}>
            <a
              href="#"
              onClick={() => window.open('/explore/popups/fractions-glossary')}
            >
              fractions glossary
            </a>
          </p>
        )}
      </div>
    </ModuleLayout>
  )

  //@* TODO THIS CAN go inside the ts file.* @
  //    @Section HeadInclude
  //@Html.ScriptTagFimCdnAnimate("/lib/math.js")

  //<script type="text/javascript">
  //    function glossary() {
  //        fim.popup("/explore/popups/fractions-glossary", 650, 300);
  //        }

  //</script>
}
